/* eslint-disable react-refresh/only-export-components */
import { differenceInDays, formatRelative } from "date-fns";
import { APP_LOCALE, dateFnsLocale } from "./locale";

/**
 * We use date-fns rather than Intl because Intl isn't yet capable of formatting relative dates as we want.
 *
 * The best we could do is this:
 *
 * const relativeDay = new Intl.RelativeTimeFormat(locale, {
 *   numeric: "auto",
 * }).format(diffInDays, "day");
 *
 * const time = new Intl.DateTimeFormat(locale, {
 *   hour: "numeric",
 *   minute: "numeric",
 * }).format(dateObj);
 *
 * return `${relativeDay} ${time}`;
 *
 * This would return relatives dates as "3 days ago 3:00 PM" which isn't ideal. We want "3 days ago at 3:00 PM".
 */

// El parámetro `locale` se conserva por compatibilidad con quienes lo llaman,
// pero la plataforma formatea siempre en español mexicano (APP_LOCALE).
export const formatLocalizedDate = (date: string, _locale?: string) =>
  new Intl.DateTimeFormat(APP_LOCALE, {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(date));

export const formatRelativeDate = (date: string, _locale?: string) => {
  const dateObj = new Date(date);
  const now = new Date();

  if (differenceInDays(now, dateObj) > 6) {
    return new Intl.DateTimeFormat(APP_LOCALE).format(dateObj);
  }

  return formatRelative(dateObj, now, { locale: dateFnsLocale });
};

export const useRelativeDate = (date: string) => formatRelativeDate(date);

export function RelativeDate({ date }: { date: string }) {
  return useRelativeDate(date);
}
